import React from "react";
import { displayName } from "../utils/theme.js";
import { paper, sans } from "./docTheme.js";

// Edit form for one item. Controlled: every change calls onChange(nextItem).
const field = { width: "100%", boxSizing: "border-box", padding: "8px 10px", border: `1px solid ${paper.line}`, borderRadius: 6, fontFamily: sans, fontSize: 14, color: paper.ink, background: paper.card };
const small = { background: "none", border: "none", color: paper.muted, cursor: "pointer", fontFamily: sans, fontSize: 12, padding: "2px 6px" };

const ownerValue = (o) => (!o ? "" : o.type === "user" ? `user:${o.userId}` : o.type);
const valueToOwner = (v) => (!v ? null : v.startsWith("user:") ? { type: "user", userId: v.slice(5) } : { type: v });

export default function ItemFields({ item, agenda, users, onChange, onRemove, onMoveUp, onMoveDown }) {
  const set = (k, v) => onChange({ ...item, [k]: v });
  return (
    <div style={{ border: `1px solid ${paper.line}`, borderRadius: 10, padding: 12, display: "flex", flexDirection: "column", gap: 8, background: "#fbfaf6" }}>
      <input aria-label="Item headline" maxLength={300} style={{ ...field, fontWeight: 600 }} value={item.headline} placeholder="Headline" onChange={(e) => set("headline", e.target.value)} />
      <textarea aria-label="Item details" maxLength={10000} style={{ ...field, minHeight: 80, resize: "vertical", lineHeight: 1.5 }} value={item.body} placeholder="Details (optional)"
        onChange={(e) => set("body", e.target.value)} />
      <div style={{ fontSize: 11, color: paper.muted }}>Blank line = new paragraph · "- " starts a bullet · **bold** · [text](https://link)</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center", fontSize: 13, color: paper.inkSoft }}>
        {!agenda && (
          <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <input type="checkbox" checked={item.decisionNeeded} onChange={(e) => set("decisionNeeded", e.target.checked)} /> Decision needed
          </label>
        )}
        <label style={{ display: "flex", alignItems: "center", gap: 6 }}>Owner
          <select aria-label="Item owner" value={ownerValue(item.owner)} onChange={(e) => set("owner", valueToOwner(e.target.value))} style={{ ...field, width: "auto", padding: "4px 8px" }}>
            <option value="">—</option>
            <option value="sawtooth">Sawtooth</option>
            <option value="client">Client</option>
            {(users || []).map((u) => <option key={u.id} value={`user:${u.id}`}>{displayName(u)}</option>)}
          </select>
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: 6 }}>Due
          <input aria-label="Item due date" type="date" value={item.dueDate || ""} onChange={(e) => set("dueDate", e.target.value || null)} style={{ ...field, width: "auto", padding: "4px 8px" }} />
        </label>
        <span style={{ flex: 1 }} />
        {onMoveUp && <button type="button" style={small} onClick={onMoveUp} aria-label="Move item up">↑</button>}
        {onMoveDown && <button type="button" style={small} onClick={onMoveDown} aria-label="Move item down">↓</button>}
        <button type="button" style={{ ...small, color: paper.danger }} onClick={onRemove}>Remove item</button>
      </div>
    </div>
  );
}
